<script>
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Meta from '@/Elements/Signals/Dark/Meta/XSmall.svelte';
  import Title from '@/Elements/Signals/Dark/Title.svelte';
  import Lead from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Text from '@/Elements/Signals/Dark/Text/Base.svelte';
  // import Preview from '@/Elements/Shapes/Cards/Preview.svelte';
  import Header from '@/Elements/Signals/Dark/Headers/Base.svelte';
  import Logo from '@/Elements/Logo.svelte';

  export let presence;

  let meta = presence.meta;
  let title = presence.title;
  let content = presence.content;
  // let img = presence.img;
</script>

<style></style>

<section id="about-us" class="py-12">
  <Container>
    <div class="flex flex-col lg:flex-row">
      <div class="px-var py-6 space-y-12 lg;w-3/5">
        <div class="space-y-3">
          <div class="space-y-1">
            <Meta>{meta}</Meta>
            <Title>{title}</Title>
          </div>
          <Lead>{content.lead}</Lead>
        </div>
        <div class="space-y-12">
          <div class="space-y-3">
            {#each content.text as text}
            <Text>{text}</Text>
            {/each}
          </div>
          <div class="space-y-3">
            <Header>{content.aux}</Header>
            <Text>{content.vision}</Text>
          </div>
        </div>
      </div>
      <div class="px-var py-12 lg:py-32 lg:w-2/5 lg:ml-auto">
        <!-- <div class="">
          <Preview item={img}></Preview>
        </div> -->
        <div class="flex flex-col h-full justify-center items-center space-y-6">
          <div class="w-32 text-center">
            <Header>{content.header}</Header>
          </div>
          <div class="">
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-3">
              {#each content.logos as logo}
              <div class="p-3">

                <Logo {logo}></Logo>
              </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</section>